/**
 * @file This file contains scripted actions for the game's demo mode.
 * @module demoScripts
 */

/**
 * Each script is an array of coordinates to be "clicked" in sequence.
 * The demo manager will pick one of these scripts at random.
 * @type {Array<Array<{r: number, c: number}>>}
 */
export const demoScripts = [
    {
        name: 'Settlement Demo',
        forcedAccessories: ['accessory_fishing_pole', 'accessory_bucket'],
        script: [
            { r: 4, c: 4 }, { r: 6, c: 4 }, { r: 5, c: 4 },
            { r: 4, c: 5 }, { r: 4, c: 3 }, { r: 4, c: 4 },
            { r: 6, c: 5 }, { r: 6, c: 3 }, { r: 6, c: 4 },
            { r: 5, c: 6 }, { r: 3, c: 6 }, { r: 4, c: 6 },
            { r: 5, c: 5 }, { r: 5, c: 7 }, { r: 5, c: 6 },
            { r: 3, c: 5 }, { r: 3, c: 3 }, { r: 3, c: 4 },
            { r: 6, c: 6 }, { r: 4, c: 6 }, { r: 5, c: 6 },
            { r: 6, c: 5 }, { r: 6, c: 7 }, { r: 6, c: 6 },
            { r: 4, c: 5 }, { r: 2, c: 5 }, { r: 3, c: 5 },
            { r: 5, c: 4 }, { r: 5, c: 2 }, { r: 5, c: 3 },
            { r: 4, c: 4 }, { r: 4, c: 2 }, { r: 4, c: 3 },
            { r: 6, c: 4 }, { r: 6, c: 2 }, { r: 6, c: 3 },
            { r: 5, c: 5 }, { r: 7, c: 5 }, { r: 6, c: 5 },
            { r: 3, c: 6 }, { r: 3, c: 4 }, { r: 3, c: 5 },
            { r: 7, c: 4 }, { r: 5, c: 4 }, { r: 6, c: 4 },
            { r: 4, c: 7 }, { r: 4, c: 5 }, { r: 4, c: 6 },
            { r: 6, c: 7 }, { r: 6, c: 5 }, { r: 6, c: 6 },
            { r: 5, c: 7 }, { r: 3, c: 7 }, { r: 4, c: 7 },
            { r: 5, c: 6 }, { r: 5, c: 8 }, { r: 5, c: 7 },
            { r: 3, c: 7 }, { r: 3, c: 5 }, { r: 3, c: 6 },
            { r: 7, c: 6 }, { r: 5, c: 6 }, { r: 6, c: 6 },
            { r: 7, c: 5 }, { r: 7, c: 7 }, { r: 7, c: 6 },
            { r: 4, c: 4 }, { r: 6, c: 4 }, { r: 5, c: 4 },
            { r: 4, c: 5 }, { r: 4, c: 3 }, { r: 4, c: 4 },
            { r: 6, c: 5 }, { r: 6, c: 3 }, { r: 6, c: 4 },
            { r: 5, c: 6 }, { r: 3, c: 6 }, { r: 4, c: 6 },
            { r: 5, c: 5 }, { r: 5, c: 7 }, { r: 5, c: 6 },
            { r: 3, c: 5 }, { r: 3, c: 3 }, { r: 3, c: 4 },
            { r: 6, c: 6 }, { r: 4, c: 6 }, { r: 5, c: 6 },
            { r: 6, c: 5 }, { r: 6, c: 7 }, { r: 6, c: 6 },
            { r: 4, c: 5 }, { r: 2, c: 5 }, { r: 3, c: 5 },
            { r: 5, c: 4 }, { r: 5, c: 2 }, { r: 5, c: 3 },
            { r: 4, c: 4 }, { r: 4, c: 2 }, { r: 4, c: 3 },
            { r: 6, c: 4 }, { r: 6, c: 2 }, { r: 6, c: 3 },
            { r: 5, c: 5 }, { r: 7, c: 5 }, { r: 6, c: 5 },
            { r: 3, c: 6 }, { r: 3, c: 4 }, { r: 3, c: 5 },
            { r: 7, c: 4 }, { r: 5, c: 4 }, { r: 6, c: 4 },
            { r: 4, c: 7 }, { r: 4, c: 5 }, { r: 4, c: 6 },
            { r: 6, c: 7 }, { r: 6, c: 5 }, { r: 6, c: 6 },
            { r: 5, c: 7 }, { r: 3, c: 7 }, { r: 4, c: 7 },
        ]
    },
    {
        name: 'The Sweeper',
        script: [
            { r: 3, c: 2 }, { r: 3, c: 4 }, { r: 3, c: 3 },
            { r: 4, c: 5 }, { r: 4, c: 7 }, { r: 4, c: 6 },
            { r: 5, c: 2 }, { r: 5, c: 4 }, { r: 5, c: 3 },
            { r: 6, c: 5 }, { r: 6, c: 7 }, { r: 6, c: 6 },
            { r: 7, c: 2 }, { r: 7, c: 4 }, { r: 7, c: 3 },
            { r: 3, c: 5 }, { r: 3, c: 7 }, { r: 3, c: 6 },
            { r: 4, c: 2 }, { r: 4, c: 4 }, { r: 4, c: 3 },
            { r: 5, c: 5 }, { r: 5, c: 7 }, { r: 5, c: 6 },
            { r: 6, c: 2 }, { r: 6, c: 4 }, { r: 6, c: 3 },
            { r: 7, c: 5 }, { r: 7, c: 7 }, { r: 7, c: 6 },
            { r: 3, c: 2 }, { r: 3, c: 4 }, { r: 3, c: 3 },
            { r: 4, c: 5 }, { r: 4, c: 7 }, { r: 4, c: 6 },
            { r: 5, c: 2 }, { r: 5, c: 4 }, { r: 5, c: 3 },
            { r: 6, c: 5 }, { r: 6, c: 7 }, { r: 6, c: 6 },
            { r: 7, c: 2 }, { r: 7, c: 4 }, { r: 7, c: 3 },
            { r: 3, c: 5 }, { r: 3, c: 7 }, { r: 3, c: 6 },
            { r: 4, c: 2 }, { r: 4, c: 4 }, { r: 4, c: 3 },
            { r: 5, c: 5 }, { r: 5, c: 7 }, { r: 5, c: 6 },
            { r: 6, c: 2 }, { r: 6, c: 4 }, { r: 6, c: 3 },
            { r: 7, c: 5 }, { r: 7, c: 7 }, { r: 7, c: 6 },
            { r: 3, c: 2 }, { r: 3, c: 4 }, { r: 3, c: 3 },
            { r: 4, c: 5 }, { r: 4, c: 7 }, { r: 4, c: 6 },
            { r: 5, c: 2 }, { r: 5, c: 4 }, { r: 5, c: 3 },
            { r: 6, c: 5 }, { r: 6, c: 7 }, { r: 6, c: 6 },
            { r: 7, c: 2 }, { r: 7, c: 4 }, { r: 7, c: 3 },
            { r: 3, c: 5 }, { r: 3, c: 7 }, { r: 3, c: 6 },
            { r: 4, c: 2 }, { r: 4, c: 4 }, { r: 4, c: 3 },
            { r: 5, c: 5 }, { r: 5, c: 7 }, { r: 5, c: 6 },
            { r: 6, c: 2 }, { r: 6, c: 4 }, { r: 6, c: 3 },
            { r: 7, c: 5 }, { r: 7, c: 7 }, { r: 7, c: 6 },
            { r: 3, c: 2 }, { r: 3, c: 4 }, { r: 3, c: 3 },
            { r: 4, c: 5 }, { r: 4, c: 7 }, { r: 4, c: 6 },
            { r: 5, c: 2 }, { r: 5, c: 4 }, { r: 5, c: 3 },
            { r: 6, c: 5 }, { r: 6, c: 7 }, { r: 6, c: 6 },
            { r: 7, c: 2 }, { r: 7, c: 4 }, { r: 7, c: 3 },
            { r: 3, c: 5 }, { r: 3, c: 7 }, { r: 3, c: 6 },
            { r: 4, c: 2 }, { r: 4, c: 4 }, { r: 4, c: 3 },
            { r: 5, c: 5 }, { r: 5, c: 7 }, { r: 5, c: 6 },
            { r: 6, c: 2 }, { r: 6, c: 4 }, { r: 6, c: 3 },
            { r: 7, c: 5 }, { r: 7, c: 7 }, { r: 7, c: 6 },
            { r: 3, c: 2 }, { r: 3, c: 4 }, { r: 3, c: 3 },
            { r: 4, c: 5 }, { r: 4, c: 7 }, { r: 4, c: 6 },
            { r: 5, c: 2 }, { r: 5, c: 4 }, { r: 5, c: 3 },
            { r: 6, c: 5 }, { r: 6, c: 7 }, { r: 6, c: 6 },
            { r: 7, c: 2 }, { r: 7, c: 4 }, { r: 7, c: 3 },
            { r: 3, c: 5 }, { r: 3, c: 7 }, { r: 3, c: 6 },
            { r: 4, c: 2 }, { r: 4, c: 4 }, { r: 4, c: 3 },
            { r: 5, c: 5 }, { r: 5, c: 7 }, { r: 5, c: 6 },
            { r: 6, c: 2 }, { r: 6, c: 4 }, { r: 6, c: 3 },
            { r: 7, c: 5 }, { r: 7, c: 7 }, { r: 7, c: 6 },
        ]
    },
    {
        name: 'The Spiral',
        script: [
            { r: 5, c: 5 }, { r: 5, c: 6 }, { r: 4, c: 6 }, { r: 5, c: 5 }, { r: 5, c: 6 }, { r: 4, c: 6 },
            { r: 5, c: 6 }, { r: 4, c: 6 }, { r: 4, c: 5 }, { r: 5, c: 6 }, { r: 4, c: 6 }, { r: 4, c: 5 },
            { r: 4, c: 6 }, { r: 4, c: 5 }, { r: 4, c: 4 }, { r: 4, c: 6 }, { r: 4, c: 5 }, { r: 4, c: 4 },
            { r: 4, c: 5 }, { r: 4, c: 4 }, { r: 5, c: 4 }, { r: 4, c: 5 }, { r: 4, c: 4 }, { r: 5, c: 4 },
            { r: 4, c: 4 }, { r: 5, c: 4 }, { r: 6, c: 4 }, { r: 4, c: 4 }, { r: 5, c: 4 }, { r: 6, c: 4 },
            { r: 5, c: 4 }, { r: 6, c: 4 }, { r: 6, c: 5 }, { r: 5, c: 4 }, { r: 6, c: 4 }, { r: 6, c: 5 },
            { r: 6, c: 4 }, { r: 6, c: 5 }, { r: 6, c: 6 }, { r: 6, c: 4 }, { r: 6, c: 5 }, { r: 6, c: 6 },
            { r: 6, c: 5 }, { r: 6, c: 6 }, { r: 5, c: 7 }, { r: 6, c: 5 }, { r: 6, c: 6 }, { r: 5, c: 7 },
            { r: 6, c: 6 }, { r: 5, c: 7 }, { r: 4, c: 7 }, { r: 6, c: 6 }, { r: 5, c: 7 }, { r: 4, c: 7 },
            { r: 5, c: 7 }, { r: 4, c: 7 }, { r: 3, c: 7 }, { r: 5, c: 7 }, { r: 4, c: 7 }, { r: 3, c: 7 },
            { r: 4, c: 7 }, { r: 3, c: 7 }, { r: 3, c: 6 }, { r: 4, c: 7 }, { r: 3, c: 7 }, { r: 3, c: 6 },
            { r: 3, c: 7 }, { r: 3, c: 6 }, { r: 3, c: 5 }, { r: 3, c: 7 }, { r: 3, c: 6 }, { r: 3, c: 5 },
            { r: 3, c: 6 }, { r: 3, c: 5 }, { r: 3, c: 4 }, { r: 3, c: 6 }, { r: 3, c: 5 }, { r: 3, c: 4 },
            { r: 3, c: 5 }, { r: 3, c: 4 }, { r: 3, c: 3 }, { r: 3, c: 5 }, { r: 3, c: 4 }, { r: 3, c: 3 },
            { r: 3, c: 4 }, { r: 3, c: 3 }, { r: 4, c: 3 }, { r: 3, c: 4 }, { r: 3, c: 3 }, { r: 4, c: 3 },
            { r: 3, c: 3 }, { r: 4, c: 3 }, { r: 5, c: 3 }, { r: 3, c: 3 }, { r: 4, c: 3 }, { r: 5, c: 3 },
            { r: 4, c: 3 }, { r: 5, c: 3 }, { r: 6, c: 3 }, { r: 4, c: 3 }, { r: 5, c: 3 }, { r: 6, c: 3 },
            { r: 5, c: 3 }, { r: 6, c: 3 }, { r: 7, c: 3 }, { r: 5, c: 3 }, { r: 6, c: 3 }, { r: 7, c: 3 },
            { r: 6, c: 3 }, { r: 7, c: 3 }, { r: 7, c: 4 }, { r: 6, c: 3 }, { r: 7, c: 3 }, { r: 7, c: 4 },
            { r: 7, c: 3 }, { r: 7, c: 4 }, { r: 7, c: 5 }, { r: 7, c: 3 }, { r: 7, c: 4 }, { r: 7, c: 5 },
            { r: 7, c: 4 }, { r: 7, c: 5 }, { r: 7, c: 6 }, { r: 7, c: 4 }, { r: 7, c: 5 }, { r: 7, c: 6 },
            { r: 7, c: 5 }, { r: 7, c: 6 }, { r: 7, c: 7 }, { r: 7, c: 5 }, { r: 7, c: 6 }, { r: 7, c: 7 },
            { r: 7, c: 6 }, { r: 7, c: 7 }, { r: 6, c: 7 }, { r: 7, c: 6 }, { r: 7, c: 7 }, { r: 6, c: 7 },
        ]
    }
];